import { GET_RIDE_ANALYTICS, GET_RIDE_DETAILS, GET_TOTAL_REGISTRATION,GET_TOPCOMPANIES,GET_COMPANY_TRIP_STATS,GET_COMPANYDATA } from "resources/actionTypes";


const initialState = {
  userRideDetails: [],
  loading: false,
  error: null,
};
const initialStateTotalRegistration = {
  userTotalRegistration: [],
  loading: false,
  error: null,
};
const initialStateRideAnalytic = {
  userRideAnalytic: [],
  loading: false,
  error: null,
};
const initialTopCompanies = {
  topCompanies: [],
  loading: false,
  error: null,
};

const initialCompanyTripStats = {
  companyTripStats: [],
  loading: false,
  error: null,
};

const initialCompanyData = {
  companyData: [],
  loading: false,
  error: null,
};

export function userRideDetails(state =
  initialState, action) {
  switch (action.type) {
    case GET_RIDE_DETAILS.GET_RIDE_DETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_RIDE_DETAILS.GET_RIDE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        userRideDetails: action.userRideDetails
      };
    case GET_RIDE_DETAILS.GET_RIDE_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userTotalRegistration(state =
  initialStateTotalRegistration, action) {
  switch (action.type) {
    case GET_TOTAL_REGISTRATION.GET_TOTAL_REGISTRATION_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_TOTAL_REGISTRATION.GET_TOTAL_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        userTotalRegistration: action.userTotalRegistration
      };
    case GET_TOTAL_REGISTRATION.GET_TOTAL_REGISTRATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userRideAnalytic(state =
  initialStateRideAnalytic, action) {
  switch (action.type) {
    case GET_RIDE_ANALYTICS.GET_RIDE_ANALYTICS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_RIDE_ANALYTICS.GET_RIDE_ANALYTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        userRideAnalytic: action.userRideAnalytic
      };
    case GET_RIDE_ANALYTICS.GET_RIDE_ANALYTICS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userTopCompanies(state =
  initialTopCompanies, action) {
  switch (action.type) {
    case GET_TOPCOMPANIES.GET_TOPCOMPANIES_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_TOPCOMPANIES.GET_TOPCOMPANIES_SUCCESS:
      return {
        ...state,
        loading: false,
        topCompanies: action.topCompanies
      };
    case GET_TOPCOMPANIES.GET_TOPCOMPANIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userCompanyTripStats(state =
  initialCompanyTripStats, action) {
  switch (action.type) {
    case GET_COMPANY_TRIP_STATS.GET_COMPANY_TRIP_STATS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_COMPANY_TRIP_STATS.GET_COMPANY_TRIP_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        companyTripStats: action.companyTripStats
      };
    case GET_COMPANY_TRIP_STATS.GET_COMPANY_TRIP_STATS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userCompanyData(state =
  initialCompanyData, action) {
  switch (action.type) {
    case GET_COMPANYDATA.GET_COMPANYDATA_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_COMPANYDATA.GET_COMPANYDATA_SUCCESS:
      return {
        ...state,
        loading: false,
        companyData: action.companyData
      };
    case GET_COMPANYDATA.GET_COMPANYDATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}